import React from "react";
import { useProjectApi } from "~/api/GeneratedApi";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";
import { useProjects } from "../Wpr/hooks/useProjects";

export const useProjectQuery = ({
  projectId,
}: {
  projectId?: number | undefined;
} = {}) => {
  const { getProject } = useProjectApi();
  const { data: projects } = useProjects();

  const { data: project } = useCustomQuery(
    { key: "project", id: projectId },
    () => {
      return getProject(projectId as number);
    },
    { enabled: projectId !== undefined },
  );
  const getProjectById = React.useCallback(
    (id: number | undefined) => {
      return projects?.find((p) => p.id === id);
    },
    [projects],
  );

  return { projects, getProjectById, project };
};
